import React, { useState } from "react";
import { Button } from "antd";
import {
  HomeOutlined,
  ShopOutlined,
  UserOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { ACCOUNT_TYPE } from "@iso/constants/onboarding";

export const ACCOUNT_TYPES = [
  {
    value: ACCOUNT_TYPE.FARM,
    icon: <HomeOutlined />,
    title: "Farm / Station / Property",
    description:
      "You own or manage a property and want to set it up in AirAgri.",
  },
  {
    value: ACCOUNT_TYPE.AG_SERVICES,
    icon: <ShopOutlined />,
    title: "Ag Services Business",
    description:
      "You provide agricultural services across multiple properties.",
  },
  {
    value: ACCOUNT_TYPE.CONTRACTOR,
    icon: <UserOutlined />,
    title: "Independent Contractor",
    description: "You work across properties as a contractor or consultant.",
  },
  {
    value: ACCOUNT_TYPE.EXISTING_PROPERTY,
    icon: <TeamOutlined />,
    title: "Joining an existing property",
    description:
      "Your property is already on AirAgri and you want to join it as staff or family.",
  },
];

// An answer is required, so the most common one starts selected.
const AccountTypeStep = ({ accountType, onNext }) => {
  const [selected, setSelected] = useState(accountType || ACCOUNT_TYPES[0].value);

  const handleContinue = () => {
    onNext(selected);
  };

  return (
    <>
      <h1 className="ob-title" tabIndex={-1}>
        How would you describe yourself?
      </h1>
      <p className="ob-lead">This helps us tailor your setup experience.</p>
      <div className="ob-choices" role="radiogroup" aria-label="Account type">
        {ACCOUNT_TYPES.map((type) => {
          const isSelected = selected === type.value;
          return (
            <label
              key={type.value}
              className={`ob-choice ${isSelected ? "is-selected" : ""}`}
            >
              <input
                type="radio"
                name="account_type"
                value={type.value}
                checked={isSelected}
                onChange={() => setSelected(type.value)}
              />
              <span className="ob-choice-icon" aria-hidden="true">
                {type.icon}
              </span>
              <span className="ob-choice-text">
                <strong>{type.title}</strong>
                <span>{type.description}</span>
              </span>
              <span className="ob-choice-dot" aria-hidden="true" />
            </label>
          );
        })}
      </div>
      <div className="ob-actions">
        <Button className="ob-btn-primary" onClick={handleContinue}>
          Continue
        </Button>
      </div>
    </>
  );
};

export default AccountTypeStep;
